import type { DocumentApi } from "../../services/api-client";
import type { UploadFile } from "../../services/upload";
import { ConversionProgress } from "./ConversionProgress";
import { ErrorPanel } from "./ErrorPanel";
import { ResultDownloads } from "./ResultDownloads";
import { UploadDropzone } from "./UploadDropzone";
import { UploadProgress } from "./UploadProgress";
import { useConversion } from "./use-conversion";

export function ConversionWorkspace({
  api,
  uploadFile,
}: {
  readonly api?: DocumentApi;
  readonly uploadFile?: UploadFile;
}) {
  const conversion = useConversion(api, uploadFile);

  if (conversion.phase === "idle") {
    return (
      <UploadDropzone onSelect={(file) => void conversion.selectFile(file)} />
    );
  }
  if (
    conversion.phase === "validating" ||
    conversion.phase === "uploading" ||
    conversion.phase === "ready"
  ) {
    return conversion.selectedFile === null ? null : (
      <UploadProgress
        file={conversion.selectedFile}
        progress={conversion.uploadProgress}
        ready={conversion.phase === "ready"}
        onRemove={() => void conversion.removeFile()}
        onConvert={() => void conversion.startConversion()}
      />
    );
  }
  if (conversion.phase === "creating" || conversion.phase === "processing") {
    const stageProps =
      conversion.job?.stage === undefined
        ? {}
        : { stage: conversion.job.stage };
    return (
      <ConversionProgress progress={conversion.progress} {...stageProps} />
    );
  }
  if (conversion.phase === "success" && conversion.job !== undefined) {
    return (
      <ResultDownloads
        job={conversion.job}
        downloadingAssetId={conversion.downloadingAssetId}
        onDownload={(assetId) => void conversion.download(assetId)}
        onReset={() => void conversion.reset()}
      />
    );
  }
  return (
    <ErrorPanel
      message={conversion.errorMessage ?? "转换失败，请重试"}
      onReset={() => void conversion.reset()}
    />
  );
}
